<template>
  <div class="pagination">
   <!-- <el-select
        class="el-input-dark mr-16px"
        v-model="size"
        @change="change"
        clearable
        filterable>
        <el-option v-for="(item, index) in sizeList" :key="index" :value="item.value" :label="item.label" />
    </el-select> -->
    <div class="right">
      <div style="margin-left: 8px;">跳至</div>
      <el-input class="el-input-dark" v-model.number="current" @input="currentChange"></el-input>
      <div>页</div>
    </div>
  </div>
</template>

<script>
const {mapState} = require('vuex')
export default {
  components: {},

  data () {
    return {
      size: 10,
      current: 1,
      sizeList: [
        {
          label: '10 条/页',
          value: 10
        }, {
          label: '20 条/页',
          value: 20
        }, {
          label: '50 条/页',
          value: 50
        }, {
          label: '100 条/页',
          value: 100
        }
      ]
    }
  },

  computed: {
    ...mapState({
    })
  },

  watch: {
  },

  created () {
  },

  mounted () {},

  methods: {
    change (e) {
      this.$emit('sizeChange', Number(e))
    },
    currentChange (e) {
      let i = e
      let num = i.charAt(i.length - 1)
      var reg = new RegExp('^[0-9]*$')
      if (!reg.test(num)) {
        this.current = i.slice(0, -1)
      } else {
        this.current = e
      }
      this.$emit('currentChange', Number(this.current))
    }
  }
}
</script>

<style lang="scss">
  .pagination{
    display: flex;
    align-items: center;
    .el-input-dark {
      width: 125px;
      .el-input__inner{
        height: 32px;
        line-height: 32px;
      }
    }
    .right{
      display: flex;
      align-items: center;
      .el-input-dark {
        width: 50px;
        margin: 0 4px 0 4px;
        .el-input__inner{
          height: 32px;
          line-height: 32px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/home/compontents/pagination.vue